import { Injectable } from '@angular/core';
import {
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * While email is verified but business verification is not yet admin-approved,
 * restrict seller dashboard child routes to onboarding/support pages only.
 */
@Injectable({ providedIn: 'root' })
export class SellerOperationalGuard implements CanActivateChild {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  canActivateChild(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.auth.sellerCanOperate()) {
      return true;
    }

    const u = this.auth.getUser();
    if (!u?.isSeller && !u?.isChildAccount) {
      return this.router.parseUrl('/sellar-login');
    }

    const path = state.url.split('?')[0];
    const allowedSegments = [
      'business-verification',
      'authenticator-security',
      'profile',
      'profile-setting',
      'notification-setting',
      'mode-setting',
      'help-center',
    ];

    if (allowedSegments.some((seg) => path.includes(`/${seg}`))) {
      return true;
    }

    return this.router.parseUrl('/seller-dashboard/business-verification');
  }
}
